import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\"> Activate Demo Version </h5><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div><div class=\"modal-body\"><p> You can activate a <b>free</b> demo version to test our products for <b>7-days</b>. You can only activate a demo version <b>once</b> for a product, if the demo expires you can no longer use the product unless you purchase it. You have <b>full access</b> and can use every feature in the demo version, the browsersource has a <b>watermark</b> in the demo version. If you make a purchase the watermark will <b>NOT</b> be visible anymore. <br><br> If you run into issues or have questions feel free to <a href=\"https://streamgames.tv/contact\" target=\"_blank\">contact us</a>. </p></div>", 2)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Close ", -1)
const _hoisted_4 = {
  key: 0,
  class: "container-fluid myCon mt-4 mb-5"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "loadingwrapper" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "container-fluid myCon mt-4 mb-5"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "loadingwrapper" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "No connection to backend server"),
  /*#__PURE__*/_createElementVNode("p", null, "Please try again later")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "container-fluid myCon mt-4 mb-5"
}
const _hoisted_11 = { class: "myMargin" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "Your Gameshows:", -1)
const _hoisted_13 = {
  key: 0,
  class: "row gy-3 mt-2"
}
const _hoisted_14 = {
  class: "card h-100",
  style: {"width":"17rem","text-align":"left"}
}
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = { class: "card-title" }
const _hoisted_19 = { class: "card-text" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "position-absolute bottom-0 end-0 mx-3 text-danger"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = {
  key: 1,
  class: "row gy-3 mt-2"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" You currently have no gameshows. "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://streamgamestv.com/shop",
      target: "blank"
    }, "Visit our shop"),
    /*#__PURE__*/_createTextVNode(" to purchase your own gameshow ")
  ])
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "myMargin mt-5" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", null, "🔥 Trending Gameshows:", -1)
const _hoisted_30 = {
  key: 0,
  class: "row gy-3 mt-2"
}
const _hoisted_31 = {
  class: "card h-100",
  style: {"width":"17rem","text-align":"left"}
}
const _hoisted_32 = ["src"]
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "card-body" }
const _hoisted_35 = { class: "card-title" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["disabled", "onClick"]
const _hoisted_41 = {
  key: 1,
  class: "col mx-4"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, "Congratulations! You own all gameshows.", -1)
const _hoisted_43 = [
  _hoisted_42
]

import { globalStore } from "@/stores/global";
import { useAuth0 } from "@auth0/auth0-vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const selectedSku = ref("");

const authClient = useAuth0();
const store = globalStore();

function redirect(url: string) {
  authClient.loginWithRedirect({
    authorizationParams: {
      redirect_uri: url,
    },
  });
}
function openNewTap(url: string) {
  // @ts-ignore
  window.open(url, "_blank").focus();
}
function hasAllGameshows() {
  if (store && store.userProductSkus && store.products) {
    for (let i = 0; i < store.products.length; i++) {
      if (!store.userProductSkus.includes(store.products[i].sku)) {
        return false;
      }
    }
    return true;
  }
}
function getDemoTimer(vergangenerZeitstempel: number) {
  // Millisekunden in einer Woche berechnen
  let eineWocheInMillisekunden = 7 * 24 * 60 * 60 * 1000;

  // Aktuellen Zeitstempel erhalten
  let jetzt = Date.now();

  // Zeitdifferenz berechnen
  let differenzInMillisekunden = jetzt - vergangenerZeitstempel;
  let verbleibendeZeitInMillisekunden =
    eineWocheInMillisekunden - differenzInMillisekunden;

  // Umrechnung der verbleibenden Zeit in Tage und Stunden
  let verbleibendeTage = Math.floor(
    verbleibendeZeitInMillisekunden / (1000 * 60 * 60 * 24)
  );
  let verbleibendeStunden = Math.floor(
    (verbleibendeZeitInMillisekunden % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  let verbleibendeMinuten = Math.floor(
    (verbleibendeZeitInMillisekunden % (1000 * 60 * 60)) / (1000 * 60)
  );

  return `${verbleibendeTage}D ${verbleibendeStunden}H ${verbleibendeMinuten}M`;
}
function getDemo(sku: string) {
  return store.demos.find((demo) => !demo.expired && demo.sku == sku);
}
function isDemoExpired(sku: string) {
  return store.demos.find((demo) => demo.expired && demo.sku == sku)?.expired;
}
function activateDemo() {
  store.activateDemo(selectedSku.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "modal fade",
      id: "exampleModal",
      tabindex: "-1",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", { class: "modal-dialog" }, [
        _createElementVNode("div", { class: "modal-content" }, [
          _hoisted_1,
          _createElementVNode("div", { class: "modal-footer" }, [
            _hoisted_3,
            _createElementVNode("button", {
              onClick: activateDemo,
              "data-bs-dismiss": "modal",
              type: "button",
              class: "btn btn-primary"
            }, " Activate ")
          ])
        ])
      ])
    ]),
    (_unref(store) && _unref(store).isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : (_unref(store) && _unref(store).isFailed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              (_unref(store) && _unref(store).products && _unref(store).userProductSkus)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).products, (product) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: product.sku,
                        class: _normalizeClass(["col-xl-3", 
            _unref(store).userProductSkus.includes(product.sku) && product.active
              ? ''
              : 'hide'
          ])
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          (product.info.img1.includes('http'))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "card-img-top",
                                src: product.info.img1,
                                alt: "Card image cap"
                              }, null, 8, _hoisted_15))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                class: "card-img-top",
                                src: require('../assets/' + product.info.img1),
                                alt: "Card image cap"
                              }, null, 8, _hoisted_16)),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("h5", _hoisted_18, _toDisplayString(product.name), 1),
                            _createElementVNode("p", _hoisted_19, _toDisplayString(product.info.headline), 1),
                            _hoisted_20,
                            _hoisted_21,
                            _createElementVNode("a", {
                              onClick: ($event: any) => (redirect(product.url)),
                              class: "btn btn-primary mt-3 position-absolute bottom-0 mb-2"
                            }, "Open", 8, _hoisted_22),
                            (getDemo(product.sku))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                                  _createTextVNode(" Demo expires in: "),
                                  _hoisted_24,
                                  _createTextVNode(" " + _toDisplayString(getDemoTimer(getDemo(product.sku)!.timestamp)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              (_unref(store) && _unref(store).products)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).products, (product) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: product.sku,
                        class: _normalizeClass(["col-xl-3", 
            _unref(store).userProductSkus.includes(product.sku) || !product.active
              ? 'hide'
              : ''
          ])
                      }, [
                        _createElementVNode("div", _hoisted_31, [
                          (product.info.img1.includes('http'))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "card-img-top",
                                src: product.info.img1,
                                alt: "Card image cap"
                              }, null, 8, _hoisted_32))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                class: "card-img-top",
                                src: require('../assets/' + product.info.img1),
                                alt: "Card image cap"
                              }, null, 8, _hoisted_33)),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("h5", _hoisted_35, _toDisplayString(product.name), 1),
                            _createElementVNode("p", {
                              class: "card-text description",
                              innerHTML: product.info.description
                            }, null, 8, _hoisted_36),
                            _hoisted_37,
                            _hoisted_38,
                            _createElementVNode("a", {
                              onClick: ($event: any) => (
                  openNewTap('https://streamgamestv.com/games/' + product.sku)
                ),
                              class: "btn btn-success mt-3 position-absolute bottom-0 mb-2"
                            }, "See more", 8, _hoisted_39),
                            _createElementVNode("button", {
                              disabled: isDemoExpired(product.sku) === true,
                              onClick: ($event: any) => (selectedSku.value = product.sku),
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#exampleModal",
                              class: "btn btn-primary position-absolute bottom-0 end-0 mx-3 mb-2"
                            }, _toDisplayString(isDemoExpired(product.sku) ? "Demo Expired" : "Activate Demo"), 9, _hoisted_40)
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (hasAllGameshows())
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
                : _createCommentVNode("", true)
            ])
          ]))
  ], 64))
}
}

})